import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import { initI18next } from "../i18next";
import { fetchConfig } from "../fetch";

export const useInit = (appNamespace: string, fetchNamespace?: string) => {
  const [loading, setLoading] = useState(true);
  const isInitialized = useRef(false);

  const initializeApp = async () => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    const config = await fetchConfig();
    const baseURL = config?.API_URL;
    const lng = config?.DEFAULT_LNG || "pl";
    axiosInstance.defaults.baseURL = baseURL || "";

    // Fetch translations
    await initI18next(appNamespace, lng?.toString(), fetchNamespace);
    setLoading(false);
  };

  useEffect(() => {
    initializeApp();
  }, []);

  return { loading };
};
